import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";

@Component({ name: "LanguageSelectorCta" })
export default class LanguageSelectorCta extends Vue {
    public country: any = {};
    public language: any = {};

    get routes() {
        return (<any>window).App.routes;
    }

    get isLanguageSelectorVisible() {
        return this.$store.getters["languageSelectorStore/isLanguageSelectorVisible"];
    }

    public async created() {
        const result = (await Axios.post(this.routes.Geo_LanguagePreview)).data;
        this.country = result.country;
        this.language = result.language;
    }

    public openLanguageSelector() {
        this.$store.commit("languageSelectorStore/setLanguageSelectorVisible", true);
    }
};